import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface PaginationState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  searchResults: any[] | null;
}

export interface PrivateLibrarySlice {
  privateLibrary: PaginationState;
  pdfUsageLogs: PaginationState;
}

const initialPaginationState: PaginationState = {
  data: null,
  currentPage: null,
  totalRecords: null,
  totalPages: null,
  searchResults: null,

};

const initialState: PrivateLibrarySlice = {
  privateLibrary: { ...initialPaginationState },
  pdfUsageLogs: { ...initialPaginationState },
};

export const privateLibrarySlice = createSlice({
  name: 'PrivateLibrary',
  initialState,
  reducers: {
    // Private Library Pagination
    setPrivateLibrary: (state, action) => {
      state.privateLibrary.data = action.payload.data.content;
      state.privateLibrary.totalRecords = action.payload.data.totalElements;
      state.privateLibrary.totalPages = action.payload.data.totalPages;
      state.privateLibrary.currentPage = action.payload.data.number;
    },
    setPrivateLibraryBySearch: (state, action) => {
      state.privateLibrary.searchResults = action?.payload?.data?.content;
      state.privateLibrary.totalRecords = action?.payload?.data?.totalElements;
      state.privateLibrary.totalPages = action?.payload?.data?.totalPages;
      state.privateLibrary.currentPage = action?.payload?.data?.number;
    },
    resetPrivateLibrary: (state) => {
      state.privateLibrary = { ...initialPaginationState };
    },

    clearPrivateLibrarySearch: (state) => {
      state.privateLibrary.searchResults = null;
      state.privateLibrary.totalRecords = null;
      state.privateLibrary.totalPages = null;
      state.privateLibrary.currentPage = null;
    },

    // PDF Usage Logs Pagination
    setPdfUsageLogs: (state, action) => {
      state.pdfUsageLogs.data = action.payload.data.content;
      state.pdfUsageLogs.totalRecords = action.payload.data.totalElements;
      state.pdfUsageLogs.totalPages = action.payload.data.totalPages;
      state.pdfUsageLogs.currentPage = action.payload.data.number;
    },
    setPdfUsageLogsBySearch: (state, action) => {
      state.pdfUsageLogs.searchResults = action.payload.data.data;
      state.pdfUsageLogs.totalRecords = action.payload.data.totalRecords;
      state.pdfUsageLogs.totalPages = action.payload.data.totalPages;
      state.pdfUsageLogs.currentPage = action.payload.data.currentPage;
    },
    resetPdfUsageLogs: (state) => {
      state.pdfUsageLogs = { ...initialPaginationState };
    },
  },
});

// Export actions
export const {
  setPrivateLibrary,
  setPrivateLibraryBySearch,
  resetPrivateLibrary,
  setPdfUsageLogs,
  setPdfUsageLogsBySearch,
  resetPdfUsageLogs,
  clearPrivateLibrarySearch
} = privateLibrarySlice.actions;

// Selectors
export const getPrivateLibraryDetails = (state: RootState) => state.privateLibrary.privateLibrary.data;
export const getPrivateLibraryTotalRecords = (state: RootState) => state.privateLibrary.privateLibrary.totalRecords;
export const getPrivateLibraryCurrentPage = (state: RootState) => state.privateLibrary.privateLibrary.currentPage;
export const getPrivateLibraryDetailsSearch = (state: RootState) => state.privateLibrary.privateLibrary.searchResults;
export const getPdfUsageLogsDetails = (state: RootState) => state.privateLibrary.pdfUsageLogs.data;
export const getPdfUsageLogsTotalRecords = (state: RootState) => state.privateLibrary.pdfUsageLogs.totalRecords;
export const getPdfUsageLogsCurrentPage = (state: RootState) => state.privateLibrary.pdfUsageLogs.currentPage;
export const getPdfUsageLogsDetailsSearch = (state: RootState) => state.privateLibrary.pdfUsageLogs.searchResults;


export default privateLibrarySlice.reducer;
